import { useEffect, useState } from "react";

const STORAGE_KEY = "studentListSize";
const VALID = ["md", "sm"];
const DEFAULT = "md";

function read() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return VALID.includes(v) ? v : DEFAULT;
  } catch {
    return DEFAULT;
  }
}

export function useStudentListSize() {
  const [size, setSize] = useState(read);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, size);
    } catch {
      /* storage may be disabled - silently ignore */
    }
  }, [size]);

  return [size, setSize];
}
